    angular.module('clients')
        .directive('clientFilter', function ($filter, Client) {
            return {
                restrict: 'E',
                require: 'ngModel',
                scope: {
                    customList: "=",
                    options: '=',
                    onChange: "&"
                },
                templateUrl: "app/clients/client-filter/client-filter.html",
                link: function (scope, $element, $attrs, ngModelCtrl) {
                    scope.clients = scope.customList || [];
                    scope.executeOnChange = scope.onChange || angular.noop;

                    scope.refreshClients = q => {
                        if(scope.customList != null){
                            scope.clients = $filter('filter')(scope.customList, q);
                        }
                        else {
                            return Client.autocomplete({q: q, includeId: scope.selected}).$promise.then(items => scope.clients = items);
                        }
                    };

                    let renderedValue;
                    ngModelCtrl.$render = () => {
                        let viewValue = ngModelCtrl.$viewValue;
                        let refreshAfterClear = !ngModelCtrl.$isEmpty(renderedValue) && ngModelCtrl.$isEmpty(viewValue);
                        scope.selected = viewValue;
                        renderedValue = viewValue;
                        if (refreshAfterClear) scope.refreshClients();
                    };
                    ngModelCtrl.$formatters.push(modelValue => angular.isUndefined(modelValue) ? null : modelValue);
                    ngModelCtrl.$parsers.push(viewValue => viewValue);

                    scope.onSelectionChanged = ($item, $model) => {
                        let view = $item ? $item.id : null;
                        ngModelCtrl.$setViewValue(view);
                        ngModelCtrl.$validate();
                        ngModelCtrl.$render();
                        if(angular.isFunction(scope.executeOnChange())){
                            scope.executeOnChange()($item);
                        }
                    }

                    let defaultOptions = {
                        placeholderKey: 'client.select.choose'
                    };
                    scope.selectOptions = angular.extend({}, defaultOptions, scope.options);
                }
            };
        });
